import script from "./CodeRainBg.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeRainBg.vue?vue&type=script&setup=true&lang=js"

import "./CodeRainBg.vue?vue&type=style&index=0&id=bf4fa12a&lang=scss"

const __exports__ = script;

export default __exports__